export enum ValidatorId {
    Required = 'required',
    Pattern = 'pattern',
    RequiredTrue = 'required',
    NullValidator = 'nullvalidator',
    MinLength = 'minlength',
    MaxLength = 'maxlength',
    Email = 'email',
    Max = 'max',
    Min = 'min',
    Between = 'between',
    InvalidValues = 'invalidValues',
    RequiredValues = 'requiredValues',
    InvalidCharacters = 'invalidCharacters',
    SqlObjectName = 'sqlObjectName',
    IsInteger = 'isInteger',
    IsNumeric = 'isNumeric',
    isAlphaNumeric = 'isAlphaNumeric',
    isAlphabetical = 'isAlphabetical',
    startsWith = 'startsWith',
    endsWith = 'endsWith'
}